import { render, staticRenderFns } from "./PacketUpgrade.vue?vue&type=template&id=006acdf1&scoped=true"
import script from "./PacketUpgrade.vue?vue&type=script&lang=js"
export * from "./PacketUpgrade.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "006acdf1",
  null
  
)

export default component.exports